import { render, staticRenderFns } from "./AscMxRecDetailWrapper.vue?vue&type=template&id=a12e34ac&"
import script from "./AscMxRecDetailWrapper.vue?vue&type=script&lang=js&"
export * from "./AscMxRecDetailWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscMxRecDetailWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports